import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function TraceabilityPackagingBarcodeViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [itemType, setItemType] = useState("");
  const [item, setItem] = useState(null);
  const [manufacturedProduct, setManufacturedProduct] = useState(null);
  const [histories, setHistories] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [notFound, setNotFound] = useState(false);

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const clearResult = () => {
    setItemType("");
    setItem(null);
    setManufacturedProduct(null);
    setHistories([]);
    setNotFound(false);
  };

  const onLookupBarcode = async function (barcode) {
    const trimmed = (barcode || "").trim();
    if (!trimmed) return;

    setLoading(true);
    setHasSearched(true);
    clearResult();

    const callResult = await makePostApiCall(`fetchPackagingBarcodeHistory`, {
      barcode: trimmed,
    });

    if (callResult.success) {
      setItemType(callResult.data?.carton_type || "");
      setItem(callResult.data?.item || null);
      setManufacturedProduct(callResult.data?.manufactured_product || null);
      setHistories(
        Array.isArray(callResult.data?.histories) ? callResult.data.histories : [],
      );
    } else if (callResult.errorStatus === 404) {
      setNotFound(true);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data?.message || "Could not fetch barcode history.");
    }

    setLoading(false);
  };

  return {
    loading,
    itemType,
    item,
    manufacturedProduct,
    histories,
    hasSearched,
    notFound,
    onLookupBarcode,
    emptyModal,
    setEmptyModelOpen,
  };
}
